<template>
	<div :class="bannerClassName">
		<div class="entrance_banner" id="entrance_banner" v-cloak>
			<div class="swiper swiper-no-swiping" ref="swiperEl">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-if="isUseEntranceAd">
							<AdBanner :grpid="grpid" :ad-unit="bannerAdUnit"></AdBanner>
					</div>
					<div class="swiper-slide" v-for="banner in bannerList">
							<Banner :image="banner.imageUrl" :link="prependHttpPrefix(banner.linkUrl)"></Banner>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isShowPagination" class="swiper-navigation">
			<button class="swiper-prev" @click="goPrev">
				<span class="ico_arr"></span>
				<span class="sr_only">이전 배너</span>
			</button>
			<button class="swiper-next" @click="goNext">
				<span class="ico_arr"></span>
				<span class="sr_only">다음 배너</span>
			</button>
		</div>
		<div v-if="isShowPagination" class="swiper-pagination" slot="pagination"></div>
	</div>
</template>

<script>
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import AdBanner from './components/AdBanner.vue';
import Banner from './components/Banner.vue';
import { prependHttpPrefix } from '../utils';

export default {
	components: {
		AdBanner, Banner,
	},
	data() {
		return {
			bannerList: [...CAFEAPP.entranceBanners],
			currentPage: 0,
			grpid: CAFEAPP.ad ? CAFEAPP.ad.cp : '',
			swiperInstance: null
		}
	},
	computed: {
		isUseEntranceAd: function () {
			if (CAFEAPP.appEntrance.advertising.adfitAds.isEnabled) {
				return true;
			}
			return CAFEAPP.ad ? CAFEAPP.ad.isEnabled : false;
		},
		bannerAdUnit: function () {
			if (CAFEAPP.appEntrance.advertising.adfitAds.isEnabled) {
				return CAFEAPP.appEntrance.advertising.adfitAds.bannerAdUnitId;
			}

			if (CAFEAPP.bannerAdUnitId) {
				return CAFEAPP.bannerAdUnitId;
			}

			return '';
		},
		totalPage: function () {
			return this.isUseEntranceAd ? this.bannerList.length + 1 : this.bannerList.length;
		},
		bannerClassName: function () {
			let className = 'entrance_banner_wrap';
			if (this.isShowPagination) {
				className += ' has-pagination';
			}
			return className;
		},
		isShowPagination: function () {
			if (this.bannerList.length > 1) {
				return true;
			}
			return this.isUseEntranceAd && this.bannerList.length >= 1;
		},
		swiper() {
			return this.swiperInstance;
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.initSwiper();
		});
	},
	beforeDestroy() {
		this.destroySwiper();
	},
	watch: {
		bannerList() {
			this.refreshSwiper();
		},
		isUseEntranceAd() {
			this.refreshSwiper();
		}
	},
	methods: {
		initSwiper() {
			if (!this.$refs.swiperEl) {
				return;
			}
			this.destroySwiper();
			const options = {
				speed: 1000,
				autoplay: {
					delay: 5000
				},
				modules: [Autoplay, Pagination]
			};
			if (this.isShowPagination) {
				options.pagination = {
					el: '.swiper-pagination'
				};
			}
			this.swiperInstance = new Swiper(this.$refs.swiperEl, options);
		},
		destroySwiper() {
			if (this.swiperInstance) {
				this.swiperInstance.destroy(true, true);
				this.swiperInstance = null;
			}
		},
		refreshSwiper() {
			this.$nextTick(() => {
				this.initSwiper();
			});
		},
		goPrev: function () {
			const swiper = this.swiper;
			if (!swiper) {
				return;
			}
			if (swiper.isBeginning) {
				swiper.slideTo(this.totalPage - 1);
				return;
			}
			swiper.slidePrev();
		},
		goNext: function () {
			const swiper = this.swiper;
			if (!swiper) {
				return;
			}
			if (swiper.isEnd) {
				swiper.slideTo(0);
				return;
			}
			swiper.slideNext();
		},
		prependHttpPrefix
	}
}
</script>
